function setButtons() {
  Geolizr.getGeoData(data => {
    let url = "";
    let urlMapper = {};

    Geolizr.addEventListener('redirect.executed', () => {
      for(let j = 0; j < Geolizr.redirects.redirects.length; j++) {
        let redirect = Geolizr.redirects.redirects[j];
        if(redirect.filterlistUrls) {
          let redirectData = redirect.filterlistUrls.split("=>");
          if(redirectData.length == 2) {
            urlMapper[redirectData[0]] = {
              "path": redirectData[1],
              "url": redirect.url
            }
          }          
        }
      }
     
      if (urlMapper[data.country.code]) {
        const cfg = urlMapper[data.country.code];

        const escapedPath = cfg.path.replace(/\//g, '\\/');
        if (location.pathname.match(escapedPath)) {
          /* normale Links */
          document.querySelectorAll('.collection-products a, .actions a')
                  .forEach(a => a.href = cfg.url);
      
          /* Buttons → Links */
          document.querySelectorAll('.actions button[type="submit"]')
                  .forEach(btn => {
                    const a = document.createElement('a');
                    a.href = cfg.url;
                    a.className = btn.className;    // Styles beibehalten
                    a.textContent = btn.textContent;
                    btn.replaceWith(a);
                  });
        }
      }
      
    })
  })
}

if(typeof Geolizr == "undefined") {
  document.addEventListener('geolizr.init', () => {
    setButtons();
  });
} else {
  setButtons();
}